import { z } from 'zod';
import { BefundAktionSchema, BefundRegelKeySchema, BefundZustaendigRolleSchema } from './befund.js';
import { IsoDateTimeSchema } from './common.js';

// ============================================================================
// Hilfe (PV-037) — docs/features/hilfe-und-news/
// ============================================================================

/** GET /v1/hilfe/datenstand — keine Regeln, keine Whitelist in der Antwort. */
export const DatenstandSchema = z.object({
  /** Ende des letzten durchgelaufenen Salesforce-Laufs (success/partial), gleich welcher Auslöser. */
  letzter_lauf_am: IsoDateTimeSchema.nullable(),
  /** Frühester nächster Termin aus den aktiven Zeitplänen (Delta + Refresh). */
  naechster_lauf_am: IsoDateTimeSchema.nullable(),
  /** Mindestens ein Zeitplan eingeschaltet. */
  automatik_an: z.boolean(),
});
export type Datenstand = z.infer<typeof DatenstandSchema>;

/** Eine aktive Prüfregel für die Hilfe — Titel/Beschreibung wie im Admin „Projekt-Prüfungen". */
export const BefundRegelHilfeSchema = z.object({
  regel: BefundRegelKeySchema,
  titel: z.string(),
  beschreibung: z.string(),
  /** Rolle im Zustand `offen` (`befundZustaendigRolle`). */
  zustaendig: BefundZustaendigRolleSchema,
  aktionen: z.array(BefundAktionSchema),
});
export type BefundRegelHilfe = z.infer<typeof BefundRegelHilfeSchema>;

/** GET /v1/hilfe/befund-regeln (nur bei Flag `befunde`). */
export const BefundRegelnHilfeSchema = z.object({
  items: z.array(BefundRegelHilfeSchema),
  /** „nach N Tagen offen wird handeln zu kritisch" — aus dem Katalog, nicht beschrieben. */
  hochstufung_nach_tagen: z.number().int().positive(),
});
export type BefundRegelnHilfe = z.infer<typeof BefundRegelnHilfeSchema>;
